// extracted by mini-css-extract-plugin
export var button = "_86-0";
export var icon = "_86-1";